import { HddOutlined, TeamOutlined, UserAddOutlined } from '@ant-design/icons';
import TcModal from 'components/UI/Modal/TcModal';
import TcTab from 'components/UI/Tab/TcTab';
import OrderAddressesList from 'components/pages/dashboard/ParcelOrder/components/orderAddressPicker/OrderAddressesList';
import OrderCreateAddress from 'components/pages/dashboard/ParcelOrder/components/orderAddressPicker/OrderCreateAddress';
import OrderPeopleAddresCustomerLinkLocation from 'components/pages/dashboard/ParcelOrder/components/orderAddressPicker/OrderPeopleAddresCustomerLinkLocation';
import endpointUrls from 'global/Constants/endpointUrls';
import { peopleAddress, peopleAddressCustomerLinkLocationsFromJet } from 'global/Models/addressModel';
import { client } from 'global/Models/clientModel';
import { IBackendSearchGeneric } from 'global/Models/globalModels';
import { lockerInfo, packageCreate } from 'global/Models/omOrderModel';
import { handleApiThenGeneric } from 'global/helperFunctions/handleApiThen';
import ApiService from 'global/utils/ApiService';
import { FC, memo, useCallback, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';

interface IOrderAddressPicker {
  close(): void;
  visible: boolean;
  setAddress: (_address: peopleAddress) => void;
  peopleAddressTypeId: 1 | 2;
  packages: packageCreate[];
  index: number;
  setLockerAddress?: (_locker: lockerInfo) => void;
  client?: client;
  isNormalOrder: boolean;
}

const OrderAddressPicker: FC<IOrderAddressPicker> = ({ close, visible, setAddress, peopleAddressTypeId, client, isNormalOrder }) => {
  //states
  const [activeTab, setActiveTab] = useState('1');
  const { userProfile } = useSelector((state: RootState) => state.user);
  const [defaultAddress, setDefaultAddress] = useState<peopleAddressCustomerLinkLocationsFromJet[]>();

  //functions
  const handleClose = () => {
    setActiveTab('1');
    close();
  };

  const handleSelectAddress = useCallback(
    (address: peopleAddress) => {
      setAddress(address);
      handleClose();
    },
    [handleClose, setAddress]
  );

  const getDefaultAddress = useCallback(async () => {
    await ApiService.post(endpointUrls.peopleAddressGetCustomerLinkLocationsFromJet, { mobileNumber: client?.mobile })
      .then((res: IBackendSearchGeneric<peopleAddressCustomerLinkLocationsFromJet>) =>
        handleApiThenGeneric({
          res,
          notifFail: false,
          notifSuccess: false,
          onSuccessData: (data) => {
            setDefaultAddress(data.length > 0 ? data : undefined);
          },
        })
      )
      .catch(() => {
        setDefaultAddress(undefined);
      });
  }, [client?.mobile]);

  //effect — reset & refetch default addresses when client changes
  useEffect(() => {
    if (userProfile && client && peopleAddressTypeId === 2 && isNormalOrder) {
      setDefaultAddress(undefined); // clear stale data from previous client
      getDefaultAddress();
    }
  }, [userProfile, client, peopleAddressTypeId, getDefaultAddress, isNormalOrder]);

  const tabs = useMemo(() => {
    const baseTabs = [
      {
        title: 'آدرس های من',
        icon: <TeamOutlined />,
        key: '1',
        content: <OrderAddressesList peopleAddressTypeId={peopleAddressTypeId} setAddress={handleSelectAddress} />,
      },
      {
        title: 'ثبت آدرس جدید',
        icon: <UserAddOutlined />,
        key: '2',
        content: <OrderCreateAddress peopleAddressTypeId={peopleAddressTypeId} setAddress={handleSelectAddress} />,
      },
    ];

    if (isNormalOrder) {
      baseTabs.push({
        title: 'آدرس پیشنهادی',
        icon: <HddOutlined />,
        key: '3',
        content: <OrderPeopleAddresCustomerLinkLocation defaultAddress={defaultAddress} setAddress={handleSelectAddress} />,
      });
    }

    return baseTabs;
  }, [peopleAddressTypeId, defaultAddress, handleSelectAddress, isNormalOrder]);

  return (
    <TcModal title='تعیین آدرس' width={990} footer={false} onCancel={handleClose} visible={visible}>
      {/* <Tabs centered items={tabs} /> */}
      <TcTab tabs={tabs} activeTab={activeTab} onChange={setActiveTab} />
    </TcModal>
  );
};

export default memo(OrderAddressPicker);
